import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IParatikaPosInsatallment } from '../models/models'

export class ListParatikaPosInsatallmentApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/posTransactionParatika/listParatikaPosInsatallment',
      requesterInfo,
    })
  }

  public async listParatikaPosInsatallment(): Promise<IParatikaPosInsatallment[]> {
    return await this.getAsync<IParatikaPosInsatallment[]>()
  }
}

